import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PreloaderService } from '@core';
import { DataService } from '@core/bootstrap/data.service';
import { LocalStorage } from '@core/bootstrap/localstorage.service';
import { AlertService } from '@shared/components/alert/alert.service';
import { LanguagePipe } from '@shared/pipes/language.pipe';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ctcreate',
  templateUrl: './ctcreate.component.html',
  styleUrls: ['./ctcreate.component.scss']
})
export class CtcreateComponent implements OnInit ,OnDestroy {
  registrationForm: FormGroup;
  users:any           = [];
  accounts:any        = [];
  branches: any       = [];
  types: any          = [];  
  isFile: boolean     = false;
  filename: any       = this.lang.transform('lang_select_files');
  constructor(public ds: DataService,public router:Router ,public lang: LanguagePipe, public ls: LocalStorage, public fb: FormBuilder, public spinner: PreloaderService, public alert: AlertService, public dialog: MatDialog, public modalService: BsModalService) {}
  ngOnInit(): void {
    this.spinner.show();
    this.registration_form();
    this.get_branches();
  }
  public registration_form() {
    this.registrationForm = new FormGroup({
      branch_id: new FormControl('', [Validators.required]),
      contractor_title_en: new FormControl('', [Validators.required]),
      contractor_title_ar: new FormControl('', [Validators.required]),
      logo : new FormControl(''),
      contractor_email_address: new FormControl('', [Validators.required, Validators.email]),
      contractor_mobile: new FormControl('', [Validators.required]),
      contractor_tax_vat: new FormControl('', [Validators.required]),
      contractor_ccr_no: new FormControl(''),
      contractor_managers: new FormControl('', [Validators.required]),
      contractor_teams: new FormControl('', [Validators.required]),
      contractor_link_with_accounts: new FormControl(0, [Validators.required]),
      contractor_address: new FormControl(''),
      contractor_credit_days: new FormControl(''),
      contractor_security_amount: new FormControl(''),
      contractor_credit_limit: new FormControl(''),
      contractor_discount_limit: new FormControl(''),
      contractor_discount_onpay: new FormControl(''),
      contractor_salesmancode: new FormControl(''),
      contractor_salesmanarea: new FormControl(''),
      contractor_stop_transaction: new FormControl(''),
      contractor_account_id: new FormControl(''),
    })
  }
  private subscriptions = new Subscription();
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  public get_branches() {
    this.subscriptions.add(
        this.ds.getActionByUrl([], 'ct/b/contractors_add').subscribe(res => {
          this.spinner.hide();
          if (res.status) {
            this.branches = res.records;
          }
        }, error => {
          this.spinner.hide();
        })      
      )

  }
  public emptyAccountFileds() {
    this.registrationForm.patchValue({
      contractor_address            : null,
      contractor_credit_days        : null,
      contractor_security_amount    : null,
      contractor_credit_limit       : null,
      contractor_discount_limit     : null,
      contractor_discount_onpay     : null,
      contractor_salesmancode       : null,
      contractor_salesmanarea       : null,
      contractor_stop_transaction   : null,
      contractor_account_id               : null,
    })
  }
  public accountSearch(key) {
    this.accounts = [];
    if (this.registrationForm.get('branch_id').value && key != undefined && key.term) {
      let param = new FormData();
      param.append('branch_id', this.registrationForm.get('branch_id').value);
      param.append('search_text', key.term);
      param.append('status', "1");
      this.subscriptions.add(
          this.ds.postActionByUrl(param, "sam/accounts_add").subscribe(data => {
            if (data.status) {
              this.accounts = data.records;
            }
          })      
        )
;
    }
  }
  public search_users(key) {
    if (this.registrationForm.get('branch_id').value && key != undefined) {
      let param = new FormData();
      param.append('branch_id', this.registrationForm.get('branch_id').value);
      param.append('search_text', key.term);
      param.append('permission_key', "contractors_add");
      this.subscriptions.add(
        this.ds.postActionByUrl(param, "ct/susers").subscribe(data => {
            if(data.status){
              this.users = data.records;
            }
        })      
        )
;
    } else {
      this.ds.dialogf('', this.lang.transform('lang_choose_branch'));
    }
  }
  public uploadFile(event) {
    if (
      event.target.files[0] &&
      event.target.files[0] !== undefined &&
      event.target.files[0].name
    ) {
      const fileid = event.target.files[0];
      this.filename = fileid.name;
      this.isFile = true;
      this.registrationForm.get("logo").setValue(fileid, { emitEvent: true });
    } else {
      this.isFile = false;
      this.registrationForm.get("logo").setValue('');
      this.filename = this.lang.transform('lang_select_files');
    }
  }
  public removeFile() {
    this.isFile = false;
    this.registrationForm.get("logo").setValue('');
    this.filename = this.lang.transform('lang_select_files');
  }
  public create() {
    this.spinner.show();
    let param = this.ds.json2formdata(this.registrationForm.value);
    if (this.registrationForm.get('contractor_link_with_accounts').value == '1') {
      param.set('contractor_account_id', this.registrationForm.get('contractor_account_id').value || '');
    }

    this.subscriptions.add(
        this.ds.postActionByUrl(param, 'ct/create').subscribe((data) => {
            this.spinner.hide();
            if (data.status) {
              this.alert.success(data.msg);
              this.registrationForm.reset();
              setTimeout(() => {
                this.router.navigate(['/contractors/view/' + data.insert_id]);
              }, 1000);
            } else {
              this.alert.error(data.error);
            }
          },(error) => {
            this.spinner.hide();
            this.alert.error((error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
          }
        )      
      )
;
  }
}
